(function (scope) {
  'use strict';
  var assetCaches = new WeakMap();
  var sizes = { Small: 80, Medium: 120 };
  var messages = {"size_small":"Small","size_medium":"Medium","letter_label":"letter {position} · {letter}","letter_generic":"a letter","size_for":"Size for {letter}","colour_for":"Colour for {letter}","colour_choice":"{colour} for {letter}","size_missing":"Size not selected","colour_missing":"Colour not selected","size_value":"{size} {mm} mm","choice_text":"{size} · {colour}","letter_choice":"Letter {position} · {letter} · {choice}","choose_name":"Type a name to choose each letter’s size and colour.","selection_progress":"{complete} of {count} letters ready. Sizes and colours are independent for each letter.","new_letters":"New letters start with no size or colour selected.","invalid_name":"Use up to 20 letters A–Z. Spaces are welcome.","letter_help":"Choose a letter to personalise its size and colour.","name_help":"Type a name above to create its letter choices.","your_name":"YOUR NAME","name_summary":"{name} · {count} letters","cart_count":"{count} personalised letters","delivery_pending":"Making takes 2–10 calendar days, depending on name length and order size. Australia Post within Australia: Standard A$12 (estimated 3–7 business days) or Express A$20 (estimated 1–3 business days), after dispatch. Shipping time is additional. Express does not shorten making time.","palette_title":"Your 21-colour range","detail_label":"{letter} in {colour}","detail_caption":"{letter} · {colour}","preview_colour":" · preview colour until you choose","zoom_unavailable":"The studio preview is still loading. Please try again in a moment.","preview_error":"The studio preview could not load. Your selections are saved; please try again.","preview_unavailable":"Studio preview unavailable for {name}.","studio_empty":"Type a name to see your studio preview.","studio_invalid":"Use A–Z and spaces, with up to 20 letters, to preview your name.","studio_updating":"Your letter selections are updating. Please choose a size and colour for each letter.","studio_loading":"Preparing your studio preview…","studio_loading_name":"Preparing studio preview of {name}.","studio_placeholder":"Your name, in the studio. Unselected sizes appear as Medium; unselected colours appear as Cotton White.","studio_ready":"Your name and selected colours. Letter sizes are shown in proportion.","studio_label":"Studio preview of {name}. {description}.","studio_letter":"Letter {position}: {letter}, {size} {mm} mm{size_note}, {colour}{colour_note}","placeholder_note":" (preview placeholder)","storage_notice":"Your selections stay in this browser until you clear them.","review_disabled":"Choose a size and colour for every letter to review your name."};
  var ratios = { '4:3': 4 / 3, '1:1': 1, '4:5': 4 / 5 };

  function canvasOf(width, height) {
    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    return canvas;
  }

  function cacheFor(assets) {
    if (!assetCaches.has(assets)) assetCaches.set(assets, { images: new Map(), photos: new Map() });
    return assetCaches.get(assets);
  }

  function imageOf(uri, cache) {
    if (typeof uri !== 'string' || !/^(?:data:image\/|https:\/\/|\/\/|\/[^\/])/.test(uri)) return Promise.reject(new Error('A photograph URL is missing.'));
    if (cache.images.has(uri)) return cache.images.get(uri);
    var job = new Promise(function (resolve, reject) {
      var image = new Image();
      if (!/^data:image\//.test(uri)) image.crossOrigin = 'anonymous';
      image.onload = function () { resolve(image); };
      image.onerror = function () { reject(new Error('A studio photograph could not be loaded.')); };
      image.src = uri;
    }).catch(function (error) { cache.images.delete(uri); throw error; });
    cache.images.set(uri, job);
    return job;
  }
  function photographOf(letter, colour, assets, cache) {
    var key = letter + '|' + colour;
    if (cache.photos.has(key)) return cache.photos.get(key);
    var job = imageOf(assets.sheets[letter], cache).then(function (image) {
      var grid = assets.grid || 5;
      var tile = Math.round(image.naturalWidth / grid);
      if (!tile || image.naturalHeight !== image.naturalWidth || image.naturalWidth % grid) throw new Error('Invalid photograph sheet.');
      var selected = assets.colours.find(function (item) { return item.name === colour; });
      if (!selected) throw new Error('Unknown colour.');
      var source = canvasOf(tile, tile);
      var mask = canvasOf(tile, tile);
      var context = source.getContext('2d', { willReadFrequently: true });
      var maskContext = mask.getContext('2d', { willReadFrequently: true });
      context.drawImage(image, (selected.tile % grid) * tile, Math.floor(selected.tile / grid) * tile, tile, tile, 0, 0, tile, tile);
      maskContext.drawImage(image, (assets.maskTile % grid) * tile, Math.floor(assets.maskTile / grid) * tile, tile, tile, 0, 0, tile, tile);
      var original = context.getImageData(0, 0, tile, tile);
      var output = context.createImageData(tile, tile);
      output.data.set(original.data);
      var maskPixels = maskContext.getImageData(0, 0, tile, tile).data;
      var opacity = new Float32Array(tile * tile);
      var visited = new Uint8Array(tile * tile);
      var largest = [];
      var i;
      for (i = 0; i < opacity.length; i++) {
        var offset = i * 4;
        var luminance = .2126 * maskPixels[offset] + .7152 * maskPixels[offset + 1] + .0722 * maskPixels[offset + 2];
        opacity[i] = Math.max(0, Math.min(1, (205 - luminance) / 45));
      }
      for (i = 0; i < opacity.length; i++) {
        if (visited[i] || opacity[i] <= .55) continue;
        var queue = [i];
        visited[i] = 1;
        for (var cursor = 0; cursor < queue.length; cursor++) {
          var pixel = queue[cursor];
          var x = pixel % tile;
          var y = Math.floor(pixel / tile);
          for (var dy = -1; dy <= 1; dy++) for (var dx = -1; dx <= 1; dx++) {
            var nx = x + dx;
            var ny = y + dy;
            var neighbour = ny * tile + nx;
            if (nx < 0 || ny < 0 || nx >= tile || ny >= tile || visited[neighbour] || opacity[neighbour] <= .55) continue;
            visited[neighbour] = 1;
            queue.push(neighbour);
          }
        }
        if (queue.length > largest.length) largest = queue;
      }
      if (!largest.length) throw new Error('Letter silhouette unavailable.');
      var allowed = new Uint8Array(tile * tile);
      var minX = tile, minY = tile, maxX = 0, maxY = 0;
      largest.forEach(function (pixel) {
        var x = pixel % tile;
        var y = Math.floor(pixel / tile);
        minX = Math.min(minX, x); maxX = Math.max(maxX, x);
        minY = Math.min(minY, y); maxY = Math.max(maxY, y);
        for (var dy = -2; dy <= 2; dy++) for (var dx = -2; dx <= 2; dx++) {
          var nx = x + dx, ny = y + dy;
          if (nx >= 0 && ny >= 0 && nx < tile && ny < tile) allowed[ny * tile + nx] = 1;
        }
      });
      for (i = 0; i < opacity.length; i++) output.data[i * 4 + 3] = allowed[i] ? Math.round(opacity[i] * 255) : 0;
      context.putImageData(output, 0, 0);
      var footprintY = maxY;
      minX = Math.max(0, minX - 2); minY = Math.max(0, minY - 2);
      maxX = Math.min(tile - 1, maxX + 2); maxY = Math.min(tile - 1, maxY + 2);
      var cropped = canvasOf(maxX - minX + 1, maxY - minY + 1);
      cropped.getContext('2d').drawImage(source, minX, minY, cropped.width, cropped.height, 0, 0, cropped.width, cropped.height);
      return { canvas: cropped, ratio: cropped.width / cropped.height, bottomInset: (maxY - footprintY) / cropped.height };
    }).catch(function (error) { cache.photos.delete(key); throw error; });
    cache.photos.set(key, job);
    return job;
  }

  scope.createTCStudioRenderer = function (canvas, assets, statusElement, translate) {
    var t = translate || function (key, values) { var text = messages[key] || key; Object.keys(values || {}).forEach(function (name) { text = text.split('{' + name + '}').join(values[name]); }); return text; };
    var context = canvas.getContext('2d');
    if (!context) throw new Error('Studio preview needs canvas support.');
    var cache = cacheFor(assets);
    var revision = 0;
    var state = { status: 'empty', name: '', layout: [] };
    canvas.setAttribute('role', 'img');

    function status(message, label, busy) {
      if (statusElement) statusElement.textContent = message;
      canvas.setAttribute('aria-label', label || message);
      canvas.setAttribute('aria-busy', busy ? 'true' : 'false');
    }
    function background(image) {
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.fillStyle = '#F3ECE2';
      context.fillRect(0, 0, canvas.width, canvas.height);
      if (!image) return;
      var fit = Math.max(canvas.width / image.naturalWidth, canvas.height / image.naturalHeight);
      var width = image.naturalWidth * fit, height = image.naturalHeight * fit;
      context.drawImage(image, (canvas.width - width) / 2, (canvas.height - height) / 2, width, height);
    }
    function render(input) {
      input = input || {};
      var request = ++revision;
      var rawName = String(input.name || '');
      var name = rawName.trim().replace(/ +/g, ' ').toUpperCase();
      var ratio = ratios[input.ratio] ? input.ratio : '4:3';
      canvas.width = 1200;
      canvas.height = Math.round(1200 / ratios[ratio]);
      canvas.style.aspectRatio = ratio.replace(':', ' / ');
      background();
      var letters = Array.from(name).filter(function (letter) { return letter !== ' '; });
      var sourceChoices = Array.isArray(input.choices) ? input.choices : [];
      var validName = /^[A-Za-z ]*$/.test(rawName) && letters.length <= 20;
      var validChoices = sourceChoices.length === letters.length && sourceChoices.every(function (choice, index) {
        return choice && choice.letter === letters[index] && (!choice.size || sizes[choice.size]) && (!choice.colour || assets.colours.some(function (colour) { return colour.name === choice.colour; }));
      });
      var snapshot = sourceChoices.map(function (choice) {
        choice = choice || {};
        return { letter: choice.letter, size: choice.size || 'Medium', colour: choice.colour || 'Cotton White', placeholderSize: !choice.size, placeholderColour: !choice.colour };
      });
      state = { status: 'loading', name: name, ratio: ratio, layout: [] };
      var backgroundJob = assets.background ? imageOf(assets.background, cache) : Promise.resolve(null);
      if (!letters.length || !validName || !validChoices) {
        var message = !letters.length ? t('studio_empty') : !validName ? t('studio_invalid') : t('studio_updating');
        state.status = !letters.length ? 'empty' : 'invalid';
        status(message);
        return backgroundJob.then(function (image) {
          if (request !== revision) return { status: 'cancelled' };
          background(image);
          return state;
        }).catch(function () { return request === revision ? state : { status: 'cancelled' }; });
      }
      status(t('studio_loading'), t('studio_loading_name', { name: name }), true);
      return Promise.all([backgroundJob, Promise.all(snapshot.map(function (choice) { return photographOf(choice.letter, choice.colour, assets, cache); }))]).then(function (result) {
        if (request !== revision) return { status: 'cancelled' };
        background(result[0]);
        var photos = result[1];
        var slots = [];
        var photoIndex = 0;
        var total = 0;
        var tallest = 0;
        Array.from(name).forEach(function (letter) {
          if (letter === ' ') { slots.push({ space: true, width: 45 }); total += 45; return; }
          var choice = snapshot[photoIndex];
          var photo = photos[photoIndex++];
          var height = sizes[choice.size];
          var width = photo.ratio * height;
          slots.push({ letter: letter, choice: choice, photo: photo, width: width, height: height });
          tallest = Math.max(tallest, height);
          total += width;
        });
        var gap = 10;
        total += Math.max(0, slots.length - 1) * gap;
        var scale = Math.min(canvas.width * .79 / total, canvas.height * .34 / tallest);
        var baseline = canvas.height * .52 + tallest * scale / 2;
        var x = (canvas.width - total * scale) / 2;
        var layout = [];
        context.imageSmoothingEnabled = true;
        context.imageSmoothingQuality = 'high';
        slots.forEach(function (slot) {
          var width = slot.width * scale;
          if (!slot.space) {
            var height = slot.height * scale;
            var shadowHeight = Math.max(2.5, height * .034);
            context.save();
            context.translate(x + width * .51, baseline - height * slot.photo.bottomInset);
            context.scale(width * .46, shadowHeight);
            var shadow = context.createRadialGradient(0, 0, 0, 0, 0, 1);
            shadow.addColorStop(0, 'rgba(75,53,44,0.15)');
            shadow.addColorStop(.4, 'rgba(75,53,44,0.055)');
            shadow.addColorStop(1, 'rgba(75,53,44,0)');
            context.fillStyle = shadow;
            context.beginPath();
            context.arc(0, 0, 1, 0, Math.PI * 2);
            context.fill();
            context.restore();
            layout.push({ letter: slot.letter, size: slot.choice.size, colour: slot.choice.colour, placeholderSize: slot.choice.placeholderSize, placeholderColour: slot.choice.placeholderColour, heightMm: slot.height, x: x, y: baseline - height, width: width, height: height });
          }
          x += width + gap * scale;
        });
        x = (canvas.width - total * scale) / 2;
        slots.forEach(function (slot) {
          var width = slot.width * scale;
          if (!slot.space) context.drawImage(slot.photo.canvas, x, baseline - slot.height * scale, width, slot.height * scale);
          x += width + gap * scale;
        });
        var placeholders = snapshot.some(function (choice) { return choice.placeholderSize || choice.placeholderColour; });
        var description = snapshot.map(function (choice, index) {
          return t('studio_letter', { position: index + 1, letter: choice.letter, size: t('size_' + choice.size.toLowerCase()), mm: sizes[choice.size], size_note: choice.placeholderSize ? t('placeholder_note') : '', colour: choice.colour, colour_note: choice.placeholderColour ? t('placeholder_note') : '' });
        }).join('; ');
        var message = placeholders ? t('studio_placeholder') : t('studio_ready');
        status(message, t('studio_label', { name: name, description: description }));
        state = { status: 'ready', name: name, ratio: ratio, placeholders: placeholders, layout: layout };
        return state;
      }).catch(function () {
        if (request !== revision) return { status: 'cancelled' };
        background();
        state = { status: 'error', name: name, ratio: ratio, layout: [] };
        status(t('preview_error'), t('preview_unavailable', { name: name }));
        return state;
      });
    }
    return { render: render, getState: function () { return JSON.parse(JSON.stringify(state)); }, destroy: function () { revision++; background(); state = { status: 'empty', name: '', layout: [] }; } };
  };
})(typeof window !== 'undefined' ? window : globalThis);
